import { render, staticRenderFns } from "./table.vue?vue&type=template&id=048e724c&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('048e724c')) {
      api.createRecord('048e724c', component.options)
    } else {
      api.reload('048e724c', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=048e724c&", function () {
      api.rerender('048e724c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_price_maintain/components/table/table.vue"
export default component.exports